function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.9166666666666666s",
  repeatCount: "indefinite"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.8333333333333334s",
  repeatCount: "indefinite"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(60 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.75s",
  repeatCount: "indefinite"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.6666666666666666s",
  repeatCount: "indefinite"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5833333333333334s",
  repeatCount: "indefinite"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(150 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5s",
  repeatCount: "indefinite"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.4166666666666667s",
  repeatCount: "indefinite"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(210 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.3333333333333333s",
  repeatCount: "indefinite"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.25s",
  repeatCount: "indefinite"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(270 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.16666666666666666s",
  repeatCount: "indefinite"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(300 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.08333333333333333s",
  repeatCount: "indefinite"
})));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(330 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#dcdcdc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
})));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      margin: 0,
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.6539cdfd.svg";
export { ForwardRef as ReactComponent };